'use strict';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fetchWrapper_1 = __importDefault(require("./fetchWrapper"));
const vue_1 = require("vue");
const AuthenticatedUser_1 = __importDefault(require("../../stores/security/AuthenticatedUser"));
const ValidationServerError_1 = __importDefault(require("../error/ValidationServerError"));
const InternalServerError_1 = __importDefault(require("../error/InternalServerError"));
const BadRequestServerError_1 = __importDefault(require("../error/BadRequestServerError"));
const ForbiddenServerError_1 = __importDefault(require("../error/ForbiddenServerError"));
const UnauthorizedServerError_1 = __importDefault(require("../error/UnauthorizedServerError"));
class ProgressState {
    static start(fetchPromise) {
        let appLoadingElement = document.getElementById('appLoading');
        if (appLoadingElement !== null) {
            appLoadingElement.style.display = 'flex';
        }
        if (!ProgressState.app) {
            const app = (0, vue_1.getCurrentInstance)();
            if (app) {
                ProgressState.app = app;
            }
        }
        ProgressState.poll++;
        fetchPromise
            .then(() => {
            ProgressState.poll--;
        })
            .catch(() => {
            ProgressState.poll--;
            ProgressState.hasFailed = true;
        })
            .finally(() => {
            if (ProgressState.poll <= 0) {
                if (appLoadingElement !== null) {
                    appLoadingElement.style.display = 'none';
                }
                ProgressState.finish();
            }
        });
    }
    static finish() {
        ProgressState.poll = 0;
        ProgressState.hasFailed = false;
    }
}
ProgressState.poll = 0;
ProgressState.hasFailed = false;
const fetch = function (request, options = {}) {
    if ('undefined' === typeof options.headers) {
        options.headers = new Headers();
    }
    if (!(options.headers instanceof Headers) && typeof options.headers === 'object') {
        options.headers = new Headers(options.headers);
    }
    if (AuthenticatedUser_1.default.getToken()) {
        options.headers.set('Authorization', `Bearer ${AuthenticatedUser_1.default.getToken()}`);
    }
    if (options.method === 'PATCH') {
        options.headers.set('Content-Type', 'application/merge-patch+json');
    }
    const promise = (0, fetchWrapper_1.default)(request, options).then(async (response) => {
        if (response.ok && response.status === 204) {
            return response;
        }
        if (response.ok) {
            return response.json();
        }
        const data = await response.json();
        if (response.status === 401) {
            throw new UnauthorizedServerError_1.default(response, data);
        }
        if (response.status === 403) {
            if (window.location.pathname !== '/login') {
                window.location.replace('/login');
            }
            throw new ForbiddenServerError_1.default(response, data);
        }
        if (response.status === 400) {
            throw new BadRequestServerError_1.default(response, data);
        }
        if (response.status === 422) {
            throw new ValidationServerError_1.default(response, data);
        }
        throw new InternalServerError_1.default(response, data);
    });
    ProgressState.start(promise);
    return promise;
};
exports.default = fetch;
